'use strict';
import isNumber from 'lodash/isNumber';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/interval';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/map';
import React, {Component} from 'react';


/**
 * @param {Component|Function} WrappedComponent
 * @param {Number|Observable} period
 * @return {Component}
 * @constructor
 */
export function Clock(WrappedComponent, period) {

  if (!isNumber(period) && !(period instanceof Observable)) {
    throw new Error('Clock missing required period');
  }

  return class ClockComponent extends Component {

    constructor(props) {
      super(props);
      this.state = {
        clock: -1,
      };
    }

    render() {
      return (
        <WrappedComponent
          clock={this.state.clock}
          {...this.props}
        />
      );
    }

    componentDidMount() {
      this.stateSubscription = ClockComponent.buildInterval$()
        .delay(0)
        .subscribe(nextState => this.setState(nextState));
    }

    componentWillUnmount() {
      this.stateSubscription && this.stateSubscription.unsubscribe();
    }

    static buildInterval$() {
      return (isNumber(period) ? Observable.interval(period) : period).map(clock => ({clock}));
    }
  };
}



// WEBPACK FOOTER //
// ./src/js/components/hocs/Clock.js